export default {"src":"/_next/static/media/pudding.342d7196.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};